import { useContext, createContext } from 'react';

export interface IOrganization {
  id: string;
  codatCompanyId: string;
  currency: string;
  logo: string | null;
  name: string;
}

export const OrgContext = createContext({} as IOrganization);

const useOrg = () => useContext(OrgContext);

export default useOrg;
